export default {
  wechatBridgeError: '加载微信框架错误',
  alipayBridgeError: '加载支付宝框架错误',
  mqqBridgeError: '加载QQ框架错误'
}
